import BursaryLayout from './BursaryLayout';
import StudentsTable from './StudentsTable';
import { connect } from 'react-redux';
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";
import SubLoading from "../../Loading/SubLoading";

const Bursary = ({ students }) => {
    
    return ( 
       <BursaryLayout>
           <div className="row pt-5">
                <div className="col s12 m10 l10 offfset-m1 offset-l1">
                    <h5 className="title is-size-5-touch has-text-weight-semibold mb-2 grey-text text-darken-3">All Students</h5>
                    <div className="divider mb-5"></div>
                    {
                        students && (   
                            students.length !== 0  ? (
                                <StudentsTable  students={students}/>
                            ) : (
                                <SubLoading />
                            )
                        )
                    }
                </div>
            </div>         
       </BursaryLayout>
     );
}
 
const mapStateToProps = (state) => {
    //console.log(state);
    return {
        students: state.firestore.ordered.students
    };
};
 
export default compose(
    connect(mapStateToProps),
        firestoreConnect((ownProps) => [
            {
                collection: "students", 
            },
    ])
)(Bursary);